import { useState } from 'react';
import { useStateContext } from '../contexts/ContextProvider';
import { GoTrash } from 'react-icons/go';
import { IoCartOutline } from 'react-icons/io5';
import { FaMinus, FaPlus } from 'react-icons/fa';

const ProductCard = ({ product, lastElementRef }) => {
    const {cartItems, setCartItems} = useStateContext();
    const [quantity, setQuantity] = useState(
      cartItems.products.find(item => item.slug === product.slug)?.quantity || 0
    );
    const isProductInCart = cartItems.products.some(item => item.slug === product.slug);
  
    const handleAddToCart = () => {
      if (!isProductInCart){
        if (quantity > 0) {
  
          const cartItem = {
            slug: product.slug,
            name: product.name,
            description: product.description,
            imageUrl: product.imageUrl,
            price: product.price,
            quantity: quantity,
          };
    
          setCartItems({
            ...cartItems,
            products: [...cartItems.products, cartItem]
          });
  
        }
      } else {
        const updatedCartItems = cartItems.products.filter(item => item.slug !== product.slug);
        setCartItems({
          ...cartItems,
          products: updatedCartItems
        });
      }
      
    };
    const handleQuantityChange = (action) => {
      if (action === 'increment') {
        setQuantity(quantity + 1);
      } else if (action === 'decrement') {
        setQuantity(quantity < 1  ? 0 : quantity - 1);;
      }
      if (isProductInCart) {
        const updatedCartItems = cartItems.products.map(item => {
          if (item.slug === product.slug) {
            return { ...item, quantity: quantity };
          }
          return item;
        });
        setCartItems({
          ...cartItems,
          products: updatedCartItems
        });
      }
    };
  
    return (
      <div ref={lastElementRef} className={`bg-slate-100 p-5 rounded-md shadow-md ${isProductInCart ? 'shadow-lg border-2 border-green-400' : ''}`}>
        <div className='flex flex-col justify-between items-center'>
        <div className='h-40 w-full bg-white rounded-md'>
            <img
              src={product.imageUrl}
              alt={product.name}
              className='w-20 h-20 object-cover rounded-md text-center mx-auto'
            />
          </div>
          <div className='flex flex-col w-full my-2'>
            <h1 className='text-xl font-bold'>{product.name}</h1>
            <p className='text-gray-500'>{product.description}</p>
          </div>
          <div className='flex justify-between w-full my-2'>
            <h1 className='text-lg font-bold'>DA {product.price}</h1>
            <div className='flex flex-row items-center gap-2'>
              <div className='flex flex-row items-center gap-2'>
                <div className='flex flex-row w-full text-xs items-center justify-center bg-slate-200 border border-gray-400 rounded-md p-0.5'>
                  <button
                    className='p-2 hover:text-white rounded-md hover:bg-blue-500'
                    onClick={() => handleQuantityChange('increment')}
                  >
                    <FaPlus />
                  </button>
                  <div className='border-l border-gray-400 h-full'></div> {/* Separator */}
                  <button
                    className='p-2 hover:text-white rounded-md hover:bg-blue-500'
                    onClick={() => handleQuantityChange('decrement')}
                  >
                    <FaMinus />
                  </button>
                </div>
                <span className='font-semibold text-sm'>{quantity}</span>
              </div>
              <button
                title={isProductInCart ? 'Remove from cart' : 'Add to cart'}
                className='bg-slate-200 border border-gray-400 hover:text-white p-2 rounded-md hover:bg-blue-500'
                onClick={handleAddToCart}
              >
                {isProductInCart ? <GoTrash /> : <IoCartOutline />}
              </button>
            </div>
          </div>
  
        </div>
      </div>
    )
  }

export default ProductCard